<span *ngIf="isListloading" class="justify-content-center">
  <app-loading [displayeMessage]="true"></app-loading>
</span>
  <div class="col-md-12">
    <div *ngFor="let feedback of feedbacks">
      <div class="callout bs-callout-info" style="word-wrap:break-word;">
        <h4>
          <span class="fa fa-comment"></span>
          <small>
            <b>{{feedback.author}}&nbsp;wrote on {{feedback.createdLocal | date:'medium'}}</b>
          </small>
        </h4>
        <span id="Image_resize" [innerHtml]="feedback.content | safeHtml"></span>
      </div>
    </div>
  </div>


